// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_mdg","cls2":"Header-cls2_Dk1 Header-cls1_mdg"};